import TimeStamp from "../../timeStamp";
import store from "@/store/store";

export default class SPIELER_MEMBERSHIP_HANDLER {

// GETTER
    static getLastValidPassNr(memberships){
        let passNrs = { regular: '', leihe: ''};
        const currentMembership = SPIELER_MEMBERSHIP_HANDLER.getMembershipForTodayOrFuture(memberships);
        passNrs.regular = currentMembership.passNr;
        /*currentMemberships.forEach( (currentMembership) => {
            if ( currentMembership.leihe ) {
                passNrs.leihe = currentMembership.passNr;
            } else {
                passNrs.regular = currentMembership.passNr;
            }
        });*/
        return passNrs;
    }
    static getMainMembershipForToday(memberships){
        const today = TimeStamp.getTodayString();
        let currentMainMemberships = memberships.filter(membership => membership.from <= today &&
                                                        membership.until >= today &&
                                                        !membership.leihe );
        return currentMainMemberships.length !== 1 ? null : currentMainMemberships[0];
    }
    static getMembershipForAufstellung(memberships, vereinsNr){
        const today = TimeStamp.getTodayString();
        let currentMemberships = memberships.filter(membership => membership.from <= today &&
                                                        membership.until >= today );
    // select leihe
        let result = null;
        if ( currentMemberships.length > 1 ) {
            const todayMonth = parseInt(today.split('-')[1]);
            if ( todayMonth >=1 && todayMonth <=6 ) {
            // use leihe
                result = currentMemberships.find(membership => membership.leihe );
            } else {
            // do not use leihe
                result = currentMemberships.find(membership => !membership.leihe);
            }
            if ( result.lvVereinId !== vereinsNr ) { result.passNr = 'ungültig'; }
        } else {
            result = currentMemberships[0]
        }
        return result;
    }
    static getMembershipsForToday(memberships){
        const today = TimeStamp.getTodayString();
    // search for current leihe
        let currentMemberships = memberships.filter(membership => membership.from <= today &&
            membership.until >= today );
    // search for future memberships if nothing is existing for today
        if ( currentMemberships.length === 0 ) {
            currentMemberships = memberships.filter(membership => membership.from > today );
            if ( currentMemberships.length > 1 ) { currentMemberships = []; }
        }
        return currentMemberships;
    }
    static getLVFromPendingMembership(spieler) {
        for ( let i = 0; i < spieler.memberships.length; i++ ) {
            if ( spieler.memberships[i].passNr === 'beantragt' ) {
                return spieler.memberships[i].lvVereinId.substr(0,2);
            }
        }
    }
    static getVereinNrFromPendingMembership(spieler) {
        for ( let i = 0; i < spieler.memberships.length; i++ ) {
            if ( spieler.memberships[i].passNr === 'beantragt' ) {
                return spieler.memberships[i].lvVereinId.substr(2);
            }
        }
    }
    static getLastSportTagFromMemberships(memberships){
        let lastSportTag = '';
        memberships.forEach( (membership) => {
            if ( !lastSportTag || membership.until > lastSportTag ) {
                lastSportTag = membership.until;
            }
        });
        return lastSportTag;
    }
    static getLastRegularMembership(memberships) {
        let lastMembership = null;
        memberships.forEach( (membership) => {
            if ( !membership.leihe &&
                ( !lastMembership || lastMembership.until < membership.until )) {
                lastMembership = membership;
            }
        });
        return lastMembership;
    }
    static getLastRegularPassNr(memberships) {
        let lastMembership = null;
        let passNr = '';
        memberships.forEach( (membership) => {
            if ( !membership.leihe &&
                ( !lastMembership || lastMembership.until < membership.until )) {
                lastMembership = membership;
                if ( lastMembership.passNr ) { passNr = lastMembership.passNr;}
            }
        });
        return passNr;
    }
    static getMembershipForTodayOrFuture(memberships){
    // 1. ist there a membership for today
        let membership = SPIELER_MEMBERSHIP_HANDLER.getMainMembershipForToday(memberships);
        if ( membership ) { return membership; }
    // 2. wenn nicht gibt es eine in der Zukunft oder in der Vergangenheit (immer die jüngste)
        return SPIELER_MEMBERSHIP_HANDLER.getLastRegularMembership(memberships);
    }

// TABELLEN AUSGABE
    static overwriteWithLeihe(item, verein, sportJahr){
        if ( item.search.leihen[sportJahr] ) {
            const currentMembership = SPIELER_MEMBERSHIP_HANDLER.getMainMembershipForToday(item.memberships);
            if ( currentMembership.lvVereinId === verein ) {
                item.local.statusDisplay = 'verliehen ab 1.1. an ' + item.search.leihen[sportJahr];
            } else {
                item.local.statusDisplay = item.search.leihen[sportJahr] === verein ?
                    'geliehen ab 1.1. von ' + currentMembership.lvVereinId :
                    item.local.statusDisplay;
                item.passNr = item.memberships.find(membership => membership.leihe).passNr;
            }
        }
        return item;
    }
    static overwriteWithLeiheSearch(item, today){
        if ( Object.keys(item.search.leihen).length > 0 ) {
            const leihe = item.memberships.find(membership => membership.leihe &&
                                                     membership.from <= today && membership.until >= today);
            return leihe ? 'verliehen ab 1.1. an ' + leihe.lvVereinId : item.status;
        } else {
            return item.status;
        }
    }
    static getCurrentLeihe(memberships){
        const currentSportJahr = store.state.local.sportJahr.current;
        return memberships.find(membership => membership.from === currentSportJahr.from &&
                                                   membership.until === currentSportJahr.until &&
                                                   membership.leihe);
    }
    static getLeiheForSportJahr(memberships, sportJahr){
        const selectedSportJahr = store.state.local.sportJahr.current.value === sportJahr ?
            store.state.local.sportJahr.current : store.state.local.sportJahr.previous.value === sportJahr ?
            store.state.local.sportJahr.previous : store.state.local.sportJahr.next.value === sportJahr ?
            store.state.local.sportJahr.next: null
        return memberships.find(membership => membership.from === selectedSportJahr?.from &&
            membership.until === selectedSportJahr?.until &&
            membership.leihe);
    }

// NEW SPIELER + PASS UPLOAD FOR UMMELDUNG
    static createNewSpieler(lvVereinId, from, until){
        return [ { lvVereinId: lvVereinId, from: from, until: until, leihe: false, passNr: 'beantragt' }]
    }
    static setPassNrToPendingMembership(membership, passNr){
        for ( let i = 0; i < membership.length; i++ ) {
            if ( membership[i].passNr === 'beantragt' ||
                membership[i].passNr === 'ummeldung' )
            { membership[i].passNr = passNr }
        }
        return membership;
    }

// EDIT SPIELER

// UMMELDUNG
    static getUmmeldung(spieler, lv, newVerein, validityRange, newPassNr){
        let memberships = JSON.parse(JSON.stringify(spieler.memberships));
        const today = TimeStamp.getTodayString();
        let currentMembership = null;
    // end current membership
        for ( let i = 0; i < memberships.length; i++ ) {
            if ( memberships[i].from <= today && memberships[i].until >= today && !memberships[i].leihe ) {
                memberships[i].until = store.state.local.sportJahr.ummeldung.yearBefore.until;
                currentMembership = memberships[i];
                break;
            }
        }
    // get last membership from the past if no current membership
        if ( !currentMembership ) {
            memberships.forEach( (membership) => {
                if ( ( !currentMembership || currentMembership.until < membership.until )
                        && !membership.leihe
                        && membership.until < today
                ) { currentMembership = membership;}
            });
        }
    // delete future memberships
        for ( let i = 0; i < memberships.length; i++ ) {
            if ( memberships[i].from >= validityRange.from && !memberships[i].leihe ) {
                memberships.splice(i, 1);
            }
        }
    // add new membership
        memberships.push({
                from: validityRange.from,
                until: validityRange.until,
                leihe: false,
                passNr: currentMembership.lvVereinId.substr(0,2) !== lv.id ? newPassNr : currentMembership.passNr,
                lvVereinId: lv.id + newVerein,
        });
    // return
        return memberships;
    }

// ABMELDUNG
    static getAbmeldung(spieler){
        let memberships = JSON.parse(JSON.stringify(spieler.memberships));
        let endDate = store.state.local.sportJahr.abmeldung.until;
    // end current membership
        for ( let i = 0; i < memberships.length; i++ ) {
            if ( memberships[i].from < endDate && memberships[i].until > endDate && !memberships[i].leihe ) {
                memberships[i].until = endDate;
                break;
            }
        }
    // delete future memberships
        for ( let i = 0; i < memberships.length; i++ ) {
            if ( memberships[i].from > endDate && !memberships[i].leihe ) {
                memberships.splice(i, 1);
            }
        }
    // return
        return memberships;
    }

// WIEDERANMELDUNG
    static getWiederanmeldung(spieler, validityRange) {
        let memberships = JSON.parse(JSON.stringify(spieler.memberships));
    // check if last existing membership can/shall be extended
        for ( let i = 0; i < memberships.length; i++ ) {
            if ( memberships[i].from <= validityRange.from &&
                 memberships[i].until >= validityRange.from &&
                !memberships[i].leihe ) {
                    memberships[i].until = validityRange.until;
                    return memberships;
            }
        }
    // create new membership
        const lastMembership = SPIELER_MEMBERSHIP_HANDLER.getLastRegularMembership(memberships);
        memberships.push({
            from: validityRange.from,
            until: validityRange.until,
            leihe: false,
            passNr: lastMembership.passNr,
            lvVereinId: lastMembership.lvVereinId,
        });
    // return
        return memberships;
    }

// WIEDERANMELDUNG
    static getVerlaengerung(spieler, validityRange) {
        let memberships = JSON.parse(JSON.stringify(spieler.memberships));
    // create new membership
        const lastMembership = SPIELER_MEMBERSHIP_HANDLER.getLastRegularMembership(memberships);
        memberships.push({
            from: validityRange.from,
            until: validityRange.until,
            leihe: false,
            passNr: lastMembership.passNr,
            lvVereinId: lastMembership.lvVereinId,
        });
    // return
        return memberships;
    }
}